module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_cart_and_boxes-36f184cefb09011ea289ab7e718189e4.svg";